import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower, capitalizeIfLower, formatDate } from '@btime/helpers'
import { compose, path } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { useOpenServiceOrderModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useServiceOrders } from '../_load/ServiceOrdersLoader'
import { useServiceOrdersActionsList } from '../../../../utils/actions/serviceOrders/list'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../packages/kiti/components/actions/Link'
import PlacePresenter from '../../../../containers/places/PlacePresenter'
import StatusTag from '../../../../containers/serviceOrders/StatusTag'
import Text, { SmallText } from '../../../../packages/kiti/components/presentation/Text'

const UsersTable = () => {
  const { t } = useTranslation()
  const data = useServiceOrders()
  const openDetailsModal = useOpenServiceOrderModal()

  const columns = [
    {
      label: `Código `,
      headerSideContent: <RefetchingIndicator />,
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 3,
      render: (value, record) => (
        <Link onClick={() => openDetailsModal(record)} block>
          <SmallText size="xsmall" color="dark2" bold>
            {record.yearlyId}
          </SmallText>
          <Text strong color="dark1" breakWord bold>
            {compose(capitalizeIfLower, path(['checklist', 'name']))(record)}
          </Text>
        </Link>
      )
    },

    {
      label: 'Usuário/Grupo',
      dataIndex: 'user',
      sortIndex: 'USER_NAME',
      format: (user, record) => capitalizeAllIfLower(user.name ?? record.group?.name),
      flex: 2.5
    },

    {
      label: 'Local/Pessoa',
      dataIndex: 'place',
      sortIndex: 'PLACE_NAME',
      flex: 3,
      render: (item, record) => <PlacePresenter place={item} size="small" color={COLORS.dark3} hideIcon breakWord />
    },

    {
      label: 'Agendamento',
      dataIndex: 'scheduling',
      sortIndex: 'SCHEDULING',
      flex: 2,
      format: formatDate('DD/MM/YY HH:mm')
    },

    {
      label: 'Status',
      dataIndex: 'status',
      sortIndex: 'STATUS_ID',
      flex: 2,
      render: (value, record) => <StatusTag item={value} />
    },

    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useServiceOrdersActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default UsersTable
